import { render, staticRenderFns } from "./VAlertGroup.vue?vue&type=template&id=322d2800&"
import script from "./VAlertGroup.vue?vue&type=script&lang=js&"
export * from "./VAlertGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports